import React from 'react';
import { motion } from 'framer-motion';
import { Download, ArrowRight } from 'lucide-react';
const REPORTS = [{
  title: 'The State of AI in the Enterprise 2026',
  abstract: 'A comprehensive survey of 1,000+ engineering and marketing leaders on how they are deploying autonomous agents in production.',
  topic: 'Industry Report',
  date: 'Q2 2026',
  pages: '42 pages'
}, {
  title: 'Measuring the Impact of Autonomous Workflows',
  abstract: 'Quantitative analysis of time saved across 50 mid-market companies after implementing Giga for 90 days.',
  topic: 'Data Study',
  date: 'Q1 2026',
  pages: '18 pages'
}, {
  title: 'Security Architectures for LLM Integrations',
  abstract: 'A technical whitepaper detailing best practices for isolating tenant data while maintaining context awareness.',
  topic: 'Whitepaper',
  date: 'Nov 2025',
  pages: '24 pages'
}, {
  title: 'The Evolution of the B2B Sales Stack',
  abstract: 'How AI is collapsing the traditional SDR/AE divide and rewriting the rules of outbound pipeline generation.',
  topic: 'Market Analysis',
  date: 'Sep 2025',
  pages: '31 pages'
}];
export function Research() {
  return <div className="min-h-screen bg-[#FAF8F4] pt-32 pb-24" data-id="element-11133" data-mp="3a9ytcefo3hk7">
      <div className="max-w-[1024px] mx-auto px-6 md:px-10" data-id="element-11134" data-mp="3o8yevd7vvgc5">
        {/* Header */}
        <div className="max-w-2xl mb-16 md:mb-24" data-id="element-11135" data-mp="3j8ap0uve55ji">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-sm font-bold tracking-widest uppercase text-[#EA580C] mb-4 block" data-id="element-11136" data-mp="3j7hhvssise0u">
            Research
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-6xl font-title font-bold text-[#2B211A] mb-6 tracking-tight leading-[1.1]" data-id="element-11137" data-mp="arpc52zn1sb4">
            Data-driven insights.
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-lg md:text-xl text-neutral-600 leading-relaxed" data-id="element-11138" data-mp="fq9018xsle64">
            Original studies, technical whitepapers, and industry reports on the
            adoption of autonomous AI in the workplace.
          </motion.p>
        </div>

        {/* List */}
        <div className="flex flex-col gap-6" data-id="element-11139" data-mp="3s9hypzdkkher">
          {REPORTS.map((report, i) => <motion.div key={report.title} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1 * i + 0.3
        }} className="group bg-white border border-neutral-200 rounded-2xl p-6 md:p-8 hover:shadow-xl hover:shadow-orange-900/5 transition-all cursor-pointer flex flex-col md:flex-row md:items-center gap-6 md:gap-10" data-id="element-11140" data-mp="140390vs803z" data-mpi={i}>
              <div className="flex-1" data-id="element-11141" data-mp="2bxcm29dgwvyr">
                <div className="flex items-center gap-3 text-xs font-medium text-neutral-500 mb-3" data-id="element-11142" data-mp="2bye0mntp00l8">
                  <span className="text-[#EA580C] uppercase tracking-wider font-bold" data-id="element-11143" data-mp="24evazypy193o">
                    {report.topic}
                  </span>
                  <span data-id="element-11144" data-mp="1um7gxbqclj8n">·</span>
                  <span data-id="element-11145" data-mp="1unilhdrmav0t">{report.date}</span>
                  <span data-id="element-11146" data-mp="1po5vik5g97u0">·</span>
                  <span data-id="element-11147" data-mp="1poxg6zxidl5i">{report.pages}</span>
                </div>
                <h2 className="text-xl md:text-2xl font-title font-bold text-[#2B211A] mb-3 group-hover:text-[#EA580C] transition-colors" data-id="element-11148" data-mp="2nbedi568ryr9">
                  {report.title}
                </h2>
                <p className="text-neutral-600 text-sm md:text-base leading-relaxed" data-id="element-11149" data-mp="2ddgo3ecnbvx2">
                  {report.abstract}
                </p>
              </div>

              <div className="shrink-0 flex items-center gap-3 text-sm font-bold text-[#2B211A]" data-id="element-11150" data-mp="29blpihm3nwmz">
                <div className="w-12 h-12 rounded-full bg-[#FAF8F4] border border-neutral-200 flex items-center justify-center group-hover:bg-[#EA580C] group-hover:text-white group-hover:border-[#EA580C] transition-colors" data-id="element-11151" data-mp="11zmoe7y4z13i">
                  <Download size={20} data-id="element-11152" data-mp="2lrl3qu48xobt" />
                </div>
                <span className="md:hidden" data-id="element-11153" data-mp="2qkwbcxgvu94s">Download PDF</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}